import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ButtonIconComponent} from './button-icon.component';

@NgModule({
  declarations: [ButtonIconComponent],
  exports: [ButtonIconComponent],
  imports: [CommonModule],
})
export class ButtonIconModule {}
